import { AnalystData, CalendarManager, ISetParams, Ratings } from '@benzinga/calendar-manager';
import { SafePromise } from '@benzinga/safe-await';
import { getSessionSingleton } from '@benzinga/session';
import CalendarService from '../lib/services/CalendarService';
import { injectLogos, injectQuotes } from '../lib/utils';

const fetchAnalystRatings = async (params = {}, injectTickersLogos = true): Promise<any> => {
  try {
    const query = {
      ...params,
      pagesize: 1000,
    };

    const Calendar = new CalendarService();

    let items: Ratings[] = [];
    const { data }: { data: { ratings: Ratings[] } } = await Calendar.getAnalystRatings(query);

    if (Array.isArray(data.ratings) && data.ratings.length) {
      items = data.ratings;
    }

    if (items.length) {
      const reqs = [injectTickersLogos ? injectLogos(items) : null, injectQuotes(items)];
      const res = await Promise.all(reqs);
      return res[1] || items;
    }
    return items;
  } catch (error) {
    return error;
  }
};

const fetchRatingsAnalysts = async (params: ISetParams = {}): SafePromise<AnalystData | null> => {
  const query = {
    fields: 'id,name_first,name_last,name_full,firm_id,firm_name,ratings_accuracy,updated',
    ...params,
  };

  const session = getSessionSingleton();
  const calendarManager = session.getManager(CalendarManager);
  const response = await calendarManager.getRatingsAnalysts(query);

  return response;
};

export { fetchAnalystRatings, fetchRatingsAnalysts };
